import {Component, Input, OnInit} from '@angular/core';
import {AbstractDisplayComponent} from '../abstract-display.component';
import {TranslateService} from '@ngx-translate/core';
import {toInteger} from 'lodash';
import {FieldTableDto} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-text-display',
    templateUrl: './text-display.component.html',
    styleUrls: ['./text-display.component.scss'],
    standalone: false
})
export class TextDisplayComponent extends AbstractDisplayComponent implements OnInit {
    href: string = null;

    constructor(protected translate: TranslateService) {
        super();
    }

    ngOnInit() {
        this.displayHover = this.value;
        this.display = this.value != null ? String(this.value) : this.value;
        try {
            // type
            if ([FieldTableDto.TypeEnum.Decimal52, FieldTableDto.TypeEnum.Decimal82, FieldTableDto.TypeEnum.Decimal112]
                .includes(this.field.type) && this.display) {
                if (this.display.includes('.')) {
                    const displaySplit = this.display.split('.');
                    for (let i = displaySplit[1].length; i < 2; i++) {
                        displaySplit[1] += '0';
                    }
                    this.display = displaySplit.join(',');
                } else {
                    this.display += ',00';
                }
            }
            // categories
            if (['PHONE', 'MOBILE'].includes(this.field.categoryField) &&
                this.value &&
                this.value.includes('+') &&
                this.value.includes('-')
            ) {
                const FrTel = (tel, sep) => tel.replace(/(\d\d(?!$))/g, '$1' + sep);
                const phone = this.value.split('-');
                this.href = 'tel:' + phone[0] + phone[1].substring(1);
                this.value = '(' + phone[0] + ') ' + FrTel(phone[1], ' ');
            } else if ('CIVILITY' === this.field.categoryField) {
                if (['MR', 'MRS'].includes(this.value?.toUpperCase())) {
                    this.display = this.translate.instant('common.' + this.value.toUpperCase());
                }
            }else if(FieldTableDto.CategoryFieldEnum.CONTACTTYPE === this.field.categoryField){
                if(['CUSTOMER', 'PROSPECT', 'SUSPECT'].includes(this.value?.toUpperCase())){
                    this.display = this.display = this.translate.instant('common.' + this.value.toUpperCase());
                }
            } else if (FieldTableDto.CategoryFieldEnum.PRICE === this.field.categoryField) {
                if (this.display != null && this.display.length > 0) {
                    this.display += ' €';
                }
                if (this.containerParent) {
                    this.containerParent.style.textAlign = 'right';
                }
            } else if (FieldTableDto.CategoryFieldEnum.NUMBER === this.field.categoryField && this.containerParent) {
                this.containerParent.style.textAlign = 'right';
            }
            this.buildAlerts();
        } catch (e) {
            console.error('field: '+JSON.stringify(this.field));
            console.error('valeur: '+this.display);
            console.error(e);
        }
    }

    getTooltip() {
    }

    onChange(event) {
        this.valueChange.emit(event);
    }

    private buildAlerts(): void {
        this.alerts.clear();
        switch (this.field.categoryField) {
            case 'CIVILITY':
                // this.value peut être undefined pour une ligne déjà importée et purgée
                // (DMP2-819) : l'absence de valeur n'est alors pas une valeur non conforme.
                if (this.value != null && !['MR', 'MRS', ''].includes(this.value.toUpperCase())) {
                    this.alerts.add(this.translate.instant('fields.validation.not-conforme'));
                }
                break;
            case 'TEXT':
                const maxlength = this.getMaxLenght();
                if (this.value && this.value.length > maxlength) {
                    this.alerts.add(this.translate.instant('fields.validation.max-lenght', {nb: maxlength}));
                }
                break;
        }
    }

    private getMaxLenght(): number {
        const nb = this.field.type.replace('String', '');
        try {
            return toInteger(nb);
        } catch (e) {
            console.log(e);
            console.log(this.field);
            return 0;
        }
    }
}
